import {
  collection,
  addDoc,
  doc,
  updateDoc,
  onSnapshot,
  serverTimestamp
} from "firebase/firestore";
import { db } from "./config";

/* ================================
   🔄 REAL-TIME LISTENER
================================ */
export const subscribeToIncomeTasks = (
  country,
  dateId,
  callback
) => {
  const tasksRef = collection(
    db,
    "incomeTeams",
    country,
    "dates",
    dateId,
    "tasks"
  );

  return onSnapshot(tasksRef, (snapshot) => {
    const tasks = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    callback(tasks);
  });
};

/* ================================
   ➕ ADD TASK
================================ */
export const addIncomeTask = async (country, dateId, task) => {
  const tasksRef = collection(
    db,
    "incomeTeams",
    country,
    "dates",
    dateId,
    "tasks"
  );

  await addDoc(tasksRef, {
    ...task,
    createdAt: serverTimestamp(),
    lastModified: serverTimestamp()
  });
};

/* ================================
   ✏️ UPDATE TASK
================================ */
export const updateIncomeTask = async (
  country,
  dateId,
  taskId,
  data
) => {
  const taskRef = doc(
    db,
    "incomeTeams",
    country,
    "dates",
    dateId,
    "tasks",
    taskId
  );

  await updateDoc(taskRef, {
    ...data,
    lastModified: serverTimestamp()
  });
};

/* ================================
   ☑️ CHECKBOX UPDATE
================================ */
export const updateCheckbox = async (
  country,
  dateId,
  taskId,
  field,
  user
) => {
  const taskRef = doc(
    db,
    "incomeTeams",
    country,
    "dates",
    dateId,
    "tasks",
    taskId
  );

  await updateDoc(taskRef, {
    [`${field}.checked`]: true,
    [`${field}.timestamp`]: serverTimestamp(),
    [`${field}.user`]: user,
    lastModified: serverTimestamp()
  });
};
